// removed by extract-text-webpack-plugin
module.exports = {"PCard":"_3A7iPaKLJc2D5NaQXuwHg5","img":"_1MJQE6rHehYtcyQE1-y_Uk","noImg":"_1VGLpubaVMC9kNj7Fc18wE","boxInfo":"_1tfADom5u-ivDDxlJfVIxA","name":"PhzHNt9giPgnqQlM9d3dg","price":"_1n0W3aBdJ-6ZFarmn3rBzF","discount":"_2qOTQZ0MgOS5UvqUl4dhpe","used":"o0EZPGh59kBonN1Tmc9OX","newPrice":"_1rjleYqiw82COwQoJ0ER2H","oldPrice":"_3gaSRsadrrhAOzigwFgflE","nameShop":"_3ix0jEGLueX7tAfAx1ana7","address":"_9Aeehsqua5AOKNIULiXZT","timeExpire":"_3rXcmfq5aeI_YvmFHmWoB5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/PCardBooking.scss
// module id = 449
// module chunks = 0